"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var getFileIcon = function (filename, defaultIcon) {
    var _a;
    if (defaultIcon)
        return defaultIcon;
    var extension = (_a = filename.split('.').pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    switch (extension) {
        case 'pdf':
            return 'aci-pdf-lg-colored';
        case 'doc':
        case 'docx':
            return 'aci-document-signing';
        case 'xls':
        case 'xlsx':
            return 'aci-document-invoice';
        default:
            return 'aci-document-filled';
    }
};
var getFileIconColor = function (filename) {
    var _a;
    var extension = (_a = filename.split('.').pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    switch (extension) {
        case 'pdf':
            return 'text-red-600';
        case 'doc':
        case 'docx':
            return 'text-blue-600';
        case 'xls':
        case 'xlsx':
            return 'text-green-600';
        default:
            return 'text-gray-600';
    }
};
var isImageFile = function (filename) {
    var _a;
    var extension = (_a = filename.split('.').pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    return ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'].includes(extension || '');
};
var ACLink = function (_a) {
    // // Use internal state to properly track links and trigger re-renders when props change
    // const [internalLinks, setInternalLinks] = useState<LinkItem[]>(links);
    var _b = _a.links, links = _b === void 0 ? [] : _b, _c = _a.target, target = _c === void 0 ? '_blank' : _c, _d = _a.containerClassName, containerClassName = _d === void 0 ? 'flex flex-wrap gap-3' : _d, linkClassName = _a.linkClassName, itemClassName = _a.itemClassName, _e = _a.iconContainerClassName, iconContainerClassName = _e === void 0 ? 'flex items-center justify-center h-28 w-full' : _e, _f = _a.iconClassName, iconClassName = _f === void 0 ? 'aci-dynamic-size size-16' : _f, _g = _a.labelClassName, labelClassName = _g === void 0 ? 'text-xs text-center text-gray-700 line-clamp-2 break-all' : _g, _h = _a.emptyMessage, emptyMessage = _h === void 0 ? '-- No documents' : _h, _j = _a.showIcon, showIcon = _j === void 0 ? true : _j, icon = _a.icon, _k = _a.emptyIcon, emptyIcon = _k === void 0 ? 'aci-document-filled' : _k, _l = _a.layout, layout = _l === void 0 ? 'grid' : _l, _m = _a.delete, enableDelete = _m === void 0 ? false : _m, onDelete = _a.onDelete, _o = _a.deleteIconClassName, deleteIconClassName = _o === void 0 ? 'aci-delete aci-dynamic-size size-4' : _o;
    // // Sync internal state with props changes
    // useEffect(() => {
    //   setInternalLinks(links);
    // }, [links]);
    var handleDelete = function (link, index, e) {
        e.preventDefault();
        e.stopPropagation();
        antd_1.Modal.confirm({
            title: 'Delete Document',
            content: "Are you sure you want to delete \"".concat(link.filename, "\"?"),
            okText: 'Delete',
            okType: 'danger',
            cancelText: 'Cancel',
            centered: true,
            icon: null,
            maskClosable: true,
            okButtonProps: {
                danger: true,
                style: {
                    backgroundColor: '#ef4444',
                    borderColor: '#ef4444',
                    color: 'white'
                }
            },
            cancelButtonProps: {
                style: {
                    borderColor: '#d1d5db',
                    color: '#374151'
                }
            },
            styles: {
                body: {
                    padding: '20px',
                    fontSize: '14px'
                },
                header: {
                    padding: '16px 20px',
                    borderBottom: '1px solid #e5e7eb'
                }
            },
            onOk: function () {
                onDelete === null || onDelete === void 0 ? void 0 : onDelete(link, index);
            }
        });
    };
    // Use linkClassName if provided, otherwise itemClassName, otherwise default
    var finalItemClassName = linkClassName || itemClassName || 'flex flex-col items-center gap-2 p-3 border border-gray-200 rounded-lg hover:shadow-md hover:border-blue-300 transition-all cursor-pointer bg-white w-[140px] h-[180px]';
    if (!links || links.length === 0) {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col items-center justify-center gap-2 p-4 text-center text-gray-400 border border-dashed border-gray-300 rounded-lg w-[140px] h-[180px]", children: [showIcon && emptyIcon && ((0, jsx_runtime_1.jsx)("div", { className: "flex items-center justify-center h-28", children: (0, jsx_runtime_1.jsx)("i", { className: "aci ".concat(emptyIcon, " aci-dynamic-size size-16 text-gray-300") }) })), (0, jsx_runtime_1.jsx)("span", { className: "text-xs", children: emptyMessage })] }));
    }
    // List layout (horizontal with icon and name)
    if (layout === 'list') {
        return ((0, jsx_runtime_1.jsx)("div", { className: "space-y-1", children: links.map(function (link, index) {
                var fileIcon = getFileIcon(link.filename, icon);
                return ((0, jsx_runtime_1.jsxs)("div", { className: "group relative flex items-center gap-2", children: [(0, jsx_runtime_1.jsxs)("a", { href: link.path, target: target, rel: target === '_blank' ? 'noopener noreferrer' : undefined, className: "flex items-center gap-2 text-sm text-blue-600 hover:text-blue-800 no-underline cursor-pointer flex-1", children: [showIcon && ((0, jsx_runtime_1.jsx)("i", { className: "aci ".concat(fileIcon, " aci-dynamic-size size-4") })), (0, jsx_runtime_1.jsx)("span", { className: "truncate", title: link.filename, children: link.filename })] }), enableDelete && onDelete && ((0, jsx_runtime_1.jsx)("button", { onClick: function (e) { return handleDelete(link, index, e); }, className: "opacity-0 group-hover:opacity-100 transition-opacity bg-red-500 hover:bg-red-600 text-white rounded-full p-1 flex items-center justify-center", title: "Delete document", children: (0, jsx_runtime_1.jsx)("i", { className: "aci ".concat(deleteIconClassName) }) }))] }, index));
            }) }));
    }
    // Grid layout (icon on top, name below - like file explorer)
    return ((0, jsx_runtime_1.jsx)("div", { className: containerClassName, children: links.map(function (link, index) {
            var _a;
            var fileIcon = getFileIcon(link.filename, icon);
            var iconColor = getFileIconColor(link.filename);
            var isImage = isImageFile(link.filename);
            var isPdf = ((_a = link.filename.split('.').pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'pdf';
            return ((0, jsx_runtime_1.jsxs)("div", { className: "relative group", children: [(0, jsx_runtime_1.jsxs)("a", { href: link.path, target: target, rel: target === '_blank' ? 'noopener noreferrer' : undefined, className: finalItemClassName, children: [showIcon && ((0, jsx_runtime_1.jsxs)("div", { className: iconContainerClassName, children: [isImage ? ((0, jsx_runtime_1.jsx)("img", { src: link.path, alt: link.filename, className: "w-20 h-20 object-cover rounded border border-gray-200", onError: function (e) {
                                            // If image fails to load, show fallback icon
                                            var target = e.currentTarget;
                                            target.style.display = 'none';
                                            var icon = target.nextElementSibling;
                                            if (icon)
                                                icon.style.display = 'flex';
                                        } })) : null, (0, jsx_runtime_1.jsx)("i", { className: "aci ".concat(fileIcon, " ").concat(iconClassName, " ").concat(isPdf ? 'aci-no-colorize' : iconColor), style: isImage ? { display: 'none' } : { display: 'flex' } })] })), (0, jsx_runtime_1.jsx)("span", { className: labelClassName, title: link.filename, children: link.filename })] }), enableDelete && onDelete && ((0, jsx_runtime_1.jsx)("button", { onClick: function (e) { return handleDelete(link, index, e); }, className: "absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity bg-red-500 hover:bg-red-600 text-white rounded-full p-1.5 flex items-center justify-center shadow-md z-10", title: "Delete document", children: (0, jsx_runtime_1.jsx)("i", { className: "aci ".concat(deleteIconClassName) }) }))] }, index));
        }) }));
};
exports.default = ACLink;
